import { ISelectorOptions } from 'components/common'
import { InvoiceFrequency } from 'generated/graphql'

export const InvoiceFrequencyValues: ISelectorOptions = [
  { value: InvoiceFrequency.Daily, label: 'Daily' },
  { value: InvoiceFrequency.Weekly, label: 'Weekly' },
]
